import LocalizedStrings from "react-localization";

import localization from "./localization.json";

export const strings = new LocalizedStrings(localization);
